<template>
  <Dialog
      :visible="modelValue"
      @update:visible="$emit('update:modelValue', $event)"
      dismissableMask
      modal
      header="Редактирование сообщения"
      :style="{ width: '75rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '95vw' }"
  >
    <div class="chat-widget__modal-content">
      <textarea
          v-model="editedText"
          class="chat-widget__modal-textarea"
          placeholder="Введите текст сообщения"
      ></textarea>
    </div>
    <template #footer>
      <Button label="Отменить" text severity="secondary" @click="cancelEdit" autofocus />
      <Button
          label="Сохранить"
          outlined
          severity="secondary"
          @click="saveEdit"
          :disabled="!editedText.trim()"
      />
    </template>
  </Dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useToastStore } from "@/modules/chat/stores/toast";
import {useChatStore} from "@/modules/chat/stores/chatStore";

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  message: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);
const toastStore = useToastStore();
const editedText = ref('');

const cancelEdit = () => {
  editedText.value = '';
  emit('update:modelValue', false);
};

watch(() => props.modelValue, (newValue) => {
  if (newValue) {
    editedText.value = props.message.text;
  }
});

const saveEdit = async () => {
  try {
    const chatStore = useChatStore();
    await chatStore.updateMessageText(props.message.id, editedText.value);
    toastStore.showSuccess('Сообщение обновлено');
    emit('update:modelValue', false);
    editedText.value = '';
  } catch (error) {
    toastStore.showError('Ошибка при обновлении сообщения');
  }
};
</script>